export default __webpack_public_path__ + "static/media/gold-card.b289d8c5.svg";